/** The workshop records the reading off a dashboard, so it counts in whole percent, not quarters. */
export const FUEL_LEVEL_STEP_PERCENTAGE = 1;
